module.exports = __webpack_public_path__ + "img/logo-light.2f2994ff.png";